import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-step-separator-line',
    templateUrl: './step-separator-line.component.html',
    styleUrls: ['./step-separator-line.component.scss'],
})
export class StepSeparatorLineComponent {
    @Input() id = -1
    @Input() length = -1

    isLastStep() {
        const isFinalId = this.id === this.length || this.id >= 5
        const isSpecialCase = this.id === 4 && (this.length === 0 || this.length === 2)

        return isFinalId || isSpecialCase
    }
}
